import { LoadingButton } from '@mui/lab';
import {
  Box,
  CircularProgress,
  Divider,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import ForaDoHorarioAtendimento from '../../../components/ForaDoHorarioAtendimento';
import AssuntoAtendimentoEnum from '../../../Enum/AssuntosAtendimentoEnum';
import { getUserData } from '../../../services/checkout-service/getUserData';
import ButtonSolicitacaoRasther from './ButtonSolicitacaoRasther';

export default function Assunto({
  navigate,
  numeroSerie,
  setUserData,
  setAssunto,
  assunto,
}) {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(true);

  const requestUserData = async () => {
    try {
      setIsLoading(true);
      const resp = await getUserData(numeroSerie);
      setUserData(resp.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    requestUserData();
  }, []);

  const handleChange = (event) => {
    setAssunto(event.target.value);
  };

  const handleSubmit = () => {
    // console.log('Selected Assunto:', assunto);

    navigate(4);
  };

  return (
    <>
      {' '}
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            textAlign: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            textAlign: 'center',
          }}
        >
          <ForaDoHorarioAtendimento />

          {/* Status do suporte */}
          <Typography
            variant="h6"
            component="h3"
            color="success.main"
            sx={{ mb: 3 }}
          >
            Suporte online
          </Typography>

          {/* Dropdown */}
          <TextField
            select
            size="medium"
            value={assunto}
            variant="outlined"
            fullWidth
            onChange={handleChange}
            sx={{ mb: 3 }}
            slotProps={{
              input: {
                style: {
                  color: theme.palette.primary.dark,
                  backgroundColor: theme.palette.background.default,
                  fontSize: 16,
                  fontWeight: 'bold', // Deixa o texto em negrito
                },
              },
              select: {
                displayEmpty: true,
                MenuProps: {
                  PaperProps: {
                    style: {
                      color: theme.palette.primary.dark,
                      backgroundColor: theme.palette.background.default,
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="" disabled>
              <div
                style={{ textAlign: 'center', width: '100%', fontWeight: 'bold' }}
              >
                Selecione o assunto
              </div>
            </MenuItem>
            {Object.entries(AssuntoAtendimentoEnum).map(([key, value]) => (
              <MenuItem key={key} value={key}>
                <div
                  style={{ textAlign: 'center', width: '100%', fontWeight: 'bold' }}
                >
                  {value}
                </div>
              </MenuItem>
            ))}
          </TextField>

          <Divider
            color={theme.palette.grey[300]}
            sx={{ width: '100%', mt: 1, mb: 1 }}
          />

          <ButtonSolicitacaoRasther sx={{ maxWidth: '290px' }} />

          <Divider
            color={theme.palette.grey[300]}
            sx={{ width: '100%', mt: 1, mb: 1 }}
          />

          <Box sx={{ display: 'flex', width: '100%', flex: 1, alignItems: 'end' }}>
            {/* Botão Enviar */}
            <LoadingButton
              disabled={assunto === ''}
              variant="contained"
              fullWidth
              onClick={handleSubmit}
              sx={{ mt: 3, fontSize: 16, height: 43 }}
            >
              Próximo
            </LoadingButton>
          </Box>
        </Box>
      )}
    </>
  );
}
